export interface EkinEntry {
    tanggal: string;
    rencana: string;
    uraian: string;
    jumlah: string | number;
    satuan: string;
    waktuMulai?: string;
    waktuSelesai?: string;
    isSelected?: boolean;
}

export function generateCSV(entries: EkinEntry[]): string {
    const header = 'tanggal,rencana,uraian,jumlah,satuan';
    const rows = entries.map((entry) => {
        const rencana = `"${entry.rencana.replace(/"/g, '""')}"`;
        const uraian = entry.uraian.replace(/"/g, '""');
        return `${entry.tanggal},${rencana},${uraian},${entry.jumlah},${entry.satuan}`;
    });
    return [header, ...rows].join('\r\n') + '\r\n';
}

export function downloadCSV(csvContent: string, filename: string): void {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export function parseCommitLogs(text: string): { number: string; description: string }[] {
    const lines = text.split('\n').filter((line) => line.trim().length > 0);
    return lines.map((line) => {
        const match = line.match(/^(\d+)\.\s*(.*)/);
        if (match) {
            return { number: match[1], description: match[2] };
        }
        return { number: '', description: line.trim() };
    });
}

export const BULAN_LIST = [
    'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
    'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember',
];

const currentYear = new Date().getFullYear();
export const TAHUN_LIST = Array.from({ length: 5 }, (_, i) => (currentYear - 2 + i).toString());

// Get working days (Mon-Fri) for a given month/year, excluding weekends
export function getWorkingDays(bulan: string, tahun: string): string[] {
    const monthIndex = BULAN_LIST.indexOf(bulan);
    if (monthIndex === -1) return [];
    const year = parseInt(tahun);
    const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
    const workingDays: string[] = [];

    for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, monthIndex, day);
        const dayOfWeek = date.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            const yyyy = year.toString();
            const mm = (monthIndex + 1).toString().padStart(2, '0');
            const dd = day.toString().padStart(2, '0');
            workingDays.push(`${yyyy}-${mm}-${dd}`);
        }
    }

    return workingDays;
}
